import request from '@teetsh/app/src/utils/request';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { USER_KEY } from '@teetsh/app/src/queries/user/useUser';
import { AxiosError } from 'axios';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { useTranslation } from 'react-i18next';

export function useLoginGoogle() {
  const queryClient = useQueryClient();
  const { notifyError } = useNotification();
  const { t } = useTranslation(['common']);

  const { mutateAsync } = useMutation<any, AxiosError, { tokenId: string }>({
    mutationFn: ({ tokenId }) =>
      request('/login-google-2', {
        method: 'POST',
        headers: { Authorization: `Bearer ${tokenId}` },
      }),

    onSuccess: response => {
      localStorage.setItem('id_token', response.token);
      localStorage.setItem('email', response.email);
      queryClient.invalidateQueries({
        queryKey: [USER_KEY],
      });
    },
    onError: () => {
      notifyError({
        title: t('common:components.user.loginGoogleError'),
      });
    },
  });
  return mutateAsync;
}
